export default __webpack_public_path__ + "static/media/arrow_left_light.0b65b6aa.svg";